
































import { Vue, Component, PropSync } from 'vue-property-decorator'

import config from '@/config'
import { CallDetailsInformation } from '@/types'
import { getCallReportingHomeURL } from '@/utils'

@Component
export default class Failed extends Vue {
  @PropSync('formStep')
  private step!: 'Details' | 'Review' | 'Confirmation' | 'Failed'

  @PropSync('callDetails')
  private data!: CallDetailsInformation

  private get isMagenta () {
    return config.isMagenta
  }

  private get getCallReportingHomeURL () {
    return getCallReportingHomeURL()
  }
}
